import React from 'react'
import DashboardLayout from '../../../components/layouts/dashboardLayout'


export default function RequestSanaTransfer() {
    return (
        <DashboardLayout>
            <div className="site-layout-background" style={{ padding: 24, textAlign: 'center' }}>
                ...
                <br />
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />

                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />
                ...
                <br />

            </div>
        </DashboardLayout>
    )

}